import React from 'react';
import { Flame } from 'lucide-react';

const PriceDisplay = ({ amountUsdt, amountFires, rates, displayCurrencies, isFiresOnly, className = '', primaryClassName = 'font-bold text-accent text-sm', secondaryClassName = 'text-[11px] text-white/60' }) => {
    const usd = Number(amountUsdt) || 0;
    const bs = usd * (rates?.bs || 38.5);
    const fires = amountFires != null ? Number(amountFires) : (usd * (rates?.fires || 10));

    // Fallback to array if string or empty
    const currencies = Array.isArray(displayCurrencies) 
        ? (displayCurrencies.length > 0 ? displayCurrencies : ['usdt']) 
        : [displayCurrencies || 'usdt'];

    if (isFiresOnly) {
        return (
            <div className={`text-right leading-tight ${className}`}>
                <div className={`text-orange-400 font-bold text-sm ${primaryClassName.replace('text-accent', '')}`}>
                    {Math.floor(fires)} <Flame className="inline w-3 h-3 -mt-0.5" />
                </div>
            </div>
        );
    }

    const renderCurrency = (code, isPrimary) => {
        if (code === 'ves') {
            return (
                <div key="ves" className={isPrimary ? primaryClassName : secondaryClassName}>
                    {!isPrimary && '≈ '}
                    {bs.toLocaleString('es-VE', { style: 'currency', currency: 'VES' })}
                </div>
            );
        } else if (code === 'fires') {
            const firesPrimaryClass = isPrimary ? primaryClassName.replace('text-accent', 'text-orange-400') : secondaryClassName;
            return (
                <div key="fires" className={firesPrimaryClass}>
                    {!isPrimary && '≈ '}
                    {Math.floor(fires)} <Flame className="inline w-3 h-3 -mt-0.5" />
                </div>
            );
        } else {
            return (
                <div key="usdt" className={isPrimary ? primaryClassName : secondaryClassName}>
                    {!isPrimary && '≈ '}
                    ${usd.toFixed(2)} USD
                </div>
            );
        }
    };

    return (
        <div className={`text-right leading-tight ${className}`}>
            {currencies.map((code, idx) => renderCurrency(code, idx === 0))}
        </div>
    );
};

export default PriceDisplay;
